import { FC, ReactNode, Suspense, memo } from 'react';
import Typography from '../Typography';
import Wallet, { WalletSkeleton } from '../Wallet';

import './ProductHeader.scss';

interface ProductHeaderProps {
  title: string;
  paymasterDisabled?: boolean;
  beforeTitle?: ReactNode;
  afterTitle?: ReactNode;
  beforeWallet?: ReactNode;
}

const ProductHeaderComponent: FC<ProductHeaderProps> = ({ title, beforeTitle, afterTitle, beforeWallet }) => {
  return (
    <div className="nostra__productHeader">
      <div className="nostra__productHeader__titleContainer">
        {beforeTitle}
        <Typography className="nostra__productHeader__title" variant="heading-lg" weight="semi-bold">
          {title}
        </Typography>
        {afterTitle}
      </div>
      <div className="nostra__productHeader__actions">
        {beforeWallet}
        <div className="nostra__productHeader__actionDesktop">
          <Suspense fallback={<WalletSkeleton />}>
            <Wallet />
          </Suspense>
        </div>
      </div>
    </div>
  );
};
export const ProductHeader = memo(ProductHeaderComponent);
